import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { GetWorkNotesQuery } from './get-work-notes.query';
import { GetWorkNotesResult } from './get-work-notes.result';

/**
 * Get work notes use case.
 * Retrieves work notes for a case.
 */
@Injectable({ providedIn: 'root' })
export class GetWorkNotesUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(query: GetWorkNotesQuery): Observable<GetWorkNotesResult> {
    this._state.setLoadingWorkNotes(true);
    this._state.setErrorWorkNotes(null);

    return this._repository.getWorkNotes(query.caseId).pipe(
      tap((workNotes) => {
        this._state.setWorkNotes(workNotes);
        this._state.setLoadingWorkNotes(false);
      }),
      map((workNotes) => ({ workNotes })),
      catchError((error) => {
        this._state.setErrorWorkNotes(error.message || 'Failed to get work notes');
        this._state.setLoadingWorkNotes(false);
        return throwError(() => error);
      })
    );
  }
}
